import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { UsersListState } from 'hooks/useGoToUsersList/useGoToUsersList.types'

export const useUsersListState = () => {
  const location = useLocation<{ UsersList: UsersListState } | undefined>()

  const state = useMemo(() => {
    if (!location.state?.UsersList) {
      return null
    }

    return { selectedUserId: location.state.UsersList.selectedUserId || null }
  }, [location.state?.UsersList])

  return { state }
}
